import React, { useState, useEffect } from 'react';
import NoticeForm from '../../components/Notices/NoticeForm';
import { createNotice, sendNotice } from '../../api/services/noticeApi';
import { unitApi } from '../../api/services/unitApi';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import toast from 'react-hot-toast';
import SettingsHeader from '../../ui/SettingsHeader';

const NoticeCreate = () => {
  const [loading, setLoading] = useState(false);
  const [classOptions, setClassOptions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchClasses() {
      try {
        const res = await unitApi.getAllUnits();
        const opts = (res.data || res || []).map(u => ({
          value: u.id || u._id,
          label: u.unitName || u.name,
          sections: u.sections || []
        }));
        setClassOptions(opts);
      } catch {
        setClassOptions([]);
      }
    }
    fetchClasses();
  }, []);

  const handleSubmit = async (data, action) => {
    setLoading(true);
    try {
      const res = await createNotice(data);
      const createdId = res?.data?._id || res?.data?.id || res?._id || res?.id;
      
      if (action === 'sent' && createdId) {
        await sendNotice(createdId);
        toast.success("Notice Created and Sent!");
      } else {
        toast.success(action === 'draft' ? "Saved as Draft" : "Notice Created");
      }
      navigate('/notices');
    } catch (error) {
      toast.error("Failed to process notice");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="animate-in fade-in duration-500 pb-10">
      <SettingsHeader
        title="Compose Notice"
        description="Create and distribute official communications to students and parents."
        showBack={true}
        onBack={() => navigate('/notices')}
        icon={Bell}
      />

      <div className="max-w-7xl mx-auto px-4 mt-6">
        <NoticeForm
          onSubmit={handleSubmit}
          classOptions={classOptions}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default NoticeCreate;
